module.exports = __webpack_public_path__ + "configuration/config_prod.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=configuration/config_prod.json!./src/config/config_prod.json
// module id = 541
// module chunks = 3